export { default } from "./src/text";
export type { UniformTextProps } from "./src/text";
